export var isEducationDataAvailable = function (level, data) {
    var _a, _b;
    if (level === void 0) { level = 'ug'; }
    if (level === 'ug') {
        if (data.ugQualification && typeof data.ugQualification === 'string') {
            if ((data.ugQualification === 'specific_ug' &&
                ((_a = data === null || data === void 0 ? void 0 : data.education) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.degree_level === 'Bachelors'; }).length) >= 1) ||
                data.ugQualification !== 'specific_ug')
                return true;
        }
        else
            return false;
    }
    else {
        if (data.pgQualification && typeof data.pgQualification === 'string') {
            if ((data.pgQualification === 'specific_pg' &&
                ((_b = data === null || data === void 0 ? void 0 : data.education) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item.degree_level === 'Masters'; }).length) >= 1) ||
                data.pgQualification !== 'specific_pg')
                return true;
        }
        else
            return false;
    }
};
export var formatEducationString = function (type, data, education) {
    if (type === void 0) { type = 'ug'; }
    if (data === void 0) { data = ''; }
    if (education === void 0) { education = []; }
    var ugString = '';
    var pgString = '';
    if (type === 'ug') {
        if (data === 'any_ug') {
            ugString = 'Any UG Qualification';
        }
        if (data === 'no_ug') {
            ugString = 'No UG';
        }
        if (data === 'specific_ug') {
            var filteredUgData_1 = education.filter(function (item) { return item.degree_level === 'Bachelors'; });
            filteredUgData_1.forEach(function (item, index) {
                ugString = ugString + item.degree_name;
                if (index + 1 !== filteredUgData_1.length) {
                    ugString = ugString + ' , ';
                }
            });
        }
        return ugString;
    }
    else {
        if (data === 'any_pg') {
            pgString = 'Any PG Qualification';
        }
        if (data === 'no_pg') {
            pgString = 'No PG';
        }
        if (data === 'specific_pg') {
            var filteredUgData_2 = education.filter(function (item) { return item.degree_level === 'Masters'; });
            filteredUgData_2.forEach(function (item, index) {
                pgString = pgString + item.degree_name;
                if (index + 1 !== filteredUgData_2.length) {
                    pgString = pgString + ' , ';
                }
            });
        }
        return pgString;
    }
};
